module.exports = __webpack_public_path__ + "img/DSC08629.0a12695e.jpg";